import Axios from 'axios';
import Qs from 'qs';

export default {

  // 账号分页列表
  listPage(
    username,
    name,
    state,
    page,
    limit
  ) {
    return Axios.get('/base/api/admin/users', {
      params: {
        filter: {
          username,
          name,
          state
        },
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加账号
  add(
    staff_id,
    is_platform_role,
    role_id,
    community_ids
  ) {
    return Axios.post('/base/api/admin/users', {
      staff_id,
      is_platform_role,
      role_id,
      community_ids
    });
  },

  // 编辑账号
  edit(
    id,
    staff_id,
    is_platform_role,
    role_id,
    community_ids
  ) {
    return Axios.patch(`/base/api/admin/users/${id}`, {
      staff_id,
      is_platform_role,
      role_id,
      community_ids
    });
  },

  // 删除账号
  del(
    id
  ) {
    return Axios.delete(`/base/api/admin/users/${id}`);
  },

  // 账号信息
  info(
    id
  ) {
    return Axios.get(`/base/api/admin/users/${id}`);
  },

  // 启用账号
  enable(
    id
  ) {
    return Axios.patch(`/base/api/admin/users/${id}/edit-state`, {
      state: 1
    });
  },

  // 禁用账号
  disable(
    id
  ) {
    return Axios.patch(`/base/api/admin/users/${id}/edit-state`, {
      state: 0
    });
  }

}